import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Collapse, ButtonPrimary } from 'core/components/ui'
import { greys, font } from 'assets/themes/theme-default'
import FilterBody from './body'
import FilterMakeModel from './make-model'
import FilterFuel from './fuel'
import FilterTransmission from './transmission'
import FilterDoor from './door'
import FilterPrice from './price'
import FilterMileage from './mileage'
import FilterConfiguration from './configuration'
import FilterYear from './year'
import FilterCH from './ch'
import FilterCV from './cv'
import FilterSeat from './seat'
import FilterEcology from './ecology'
//import FilterTraction from './traction'
import FilterColor from './color'

const FilterWrapper = styled.div`
  margin-bottom: 20px;
`
const { Panel } = Collapse

const StyledPanel = styled(Panel)``

const Header = styled.div`
  background: ${greys.light4};
  height: 40px;
  :before {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    background: ${greys.dark3};
    top: 50%;
  }
  :after {
    transition: all 500ms;
    box-sizing: content-box;
    content: '+';
    position: absolute;
    width: 40px;
    height: 40px;
    top: 50%;
    left: 50%;
    margin: -30px 0 0 -30px;
    background: ${props => props.theme.colors.color2.bg};
    color: ${greys.light4};
    font-size: ${font.size.lgxxl};
    font-weight: ${font.weight.base};
    text-align: center;
    line-height: 40px;
    border: 10px solid ${greys.light4};
    transition: none;
  }
`
const StyledCollapse = styled(Collapse)`
  &&& {
    background-color: transparent;
    border: 0 none;
    > .ant-collapse-item {
      border: 0 none;
      &.ant-collapse-no-arrow > .ant-collapse-header {
        padding-left: 0px;
      }
      &.ant-collapse-item-active {
        ${Header} {
          :after {
            content: '-';
            line-height: 33px;
          }
        }
      }
      .ant-collapse-content {
        overflow: visible;
        border: 0 none;
      }
      .ant-collapse-content > .ant-collapse-content-box {
        padding: 0px;
      }
    }
  }
`

const Filters = props => {
  const headerCollapse = <Header />
  const { reinInitFilters, loading, onChangeFilter, filters, filtersDatas } = props
  /*
<FilterWrapper>
          <FilterTraction
            onChangeFilter={onChangeFilter}
            filters={filters}
            filtersDatas={filtersDatas}
          />
        </FilterWrapper>
*/
  return (
    <>
      <FilterWrapper>
        <FilterBody
          loading={loading}
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterMakeModel
          loading={loading}
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterConfiguration
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterFuel
          loading={loading}
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterTransmission
          loading={loading}
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterDoor onChangeFilter={onChangeFilter} filters={filters} filtersDatas={filtersDatas} />
      </FilterWrapper>
      <FilterWrapper>
        <FilterMileage
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterPrice
          onChangeFilter={onChangeFilter}
          filters={filters}
          filtersDatas={filtersDatas}
        />
      </FilterWrapper>
      <FilterWrapper>
        <FilterYear onChangeFilter={onChangeFilter} filters={filters} filtersDatas={filtersDatas} />
        {/*pt in colpase/*/}
      </FilterWrapper>
      <StyledCollapse>
        <StyledPanel header={headerCollapse} key="1" showArrow={false}>
          <FilterWrapper>
            <FilterCV
              onChangeFilter={onChangeFilter}
              filters={filters}
              filtersDatas={filtersDatas}
            />
          </FilterWrapper>
          <FilterWrapper>
            <FilterCH
              onChangeFilter={onChangeFilter}
              filters={filters}
              filtersDatas={filtersDatas}
            />
          </FilterWrapper>
          <FilterWrapper>
            <FilterSeat
              onChangeFilter={onChangeFilter}
              filters={filters}
              filtersDatas={filtersDatas}
            />
          </FilterWrapper>
          <FilterWrapper>
            <FilterEcology
              onChangeFilter={onChangeFilter}
              filters={filters}
              filtersDatas={filtersDatas}
            />
          </FilterWrapper>
          <FilterWrapper>
            <FilterColor
              onChangeFilter={onChangeFilter}
              filters={filters}
              filtersDatas={filtersDatas}
            />
          </FilterWrapper>
        </StyledPanel>
      </StyledCollapse>
      <FilterWrapper>
        <ButtonPrimary onClick={reinInitFilters} style={{ width: '100%' }}>
          <FormattedMessage id="stock-vehicles-list-filters-button-1" />
        </ButtonPrimary>
      </FilterWrapper>
    </>
  )
}

Filters.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  reinInitFilters: PropTypes.func.isRequired
}

export default Filters
